<script setup lang="ts">

import Picture from './Picture.vue';

const props = defineProps<{
    href: string,
    title: string,
    text: string,
    extraText?: string,
    img: string,
    partof: string,
}>();

</script>

<template>
    <article class="teaser">
        <div class="overlay-icon" v-if="props.partof == 'Tag des Bades'"></div>
        <div class="thumb" v-if="props.img != ''">
            <Picture 
                :href="props.href"
                :src="props.img" 
                width="268"
                height="178"
                action="tf"
            />
        </div>
        <div class="content">
            <h3>
                <a :href="props.href">
                    {{ title }}
                </a>
            </h3>
            <p>{{ text }}</p>
            <p v-if="props.extraText">{{ extraText }}</p>
        </div>
    </article>
</template>
